import { KhoService } from 'src/services/kho.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const KHO_NEW_CARE_SUCCESS = 'KHO:NEW_CARE_SUCCESS'
export const KHO_LIST_SUCCESS = 'KHO:FIND_ALL_SUCCESS'
export const KHO_LIST_FAILD = 'KHO:FIND_ALL_FAILD'
export const KHO_COUNT_ASSIGN_SUCCESS = 'KHO:COUNT_ASSIGN_SUCCESS'
export const KHO_COUNT_ASSIGN_FAILD = 'KHO:COUNT_ASSIGN_FAILD'

export const KHO_CREATE_SUCCESS = 'KHO:CREATE_SUCCESS'
export const KHO_CREATE_FAILD = 'KHO:CREATE_FAILD'

export const KHO_IMPORT_SUCCESS = 'KHO:IMPORT_SUCCESS'
export const KHO_SAVE_SUCCESS = 'KHO:SAVE_SUCCESS'
export const KHO_SAVE_FAILD = 'KHO:SAVE_SUCCESS'

export const KHO_DEL_SUCCESS = 'KHO:DEL_SUCCESS'
export const KHO_DEL_FAILD = 'KHO:DEL_FAILD'

export const KHO_ONE_SUCCESS = 'KHO:FIND_ONE_SUCCESS'
export const KHO_ONE_FAILD = 'KHO:FIND_ONE_FAILD'

export const KHO_HISTORY_LIST_SUCCESS = 'KHO:HISTORY_FIND_ALL_SUCCESS'
export const KHO_HISTORY_LIST_FAILD = 'KHO:HISTORY_FIND_ALL_FAILD'

export const KHO_UPDATE_FILTER = 'KHO:UPDATE_FILTER'

export const KHO_ORDER_SUCCESS = 'KHO:ORDER_SUCCESS'
export const KHO_ORDER_FAILD = 'KHO:ORDER_FAILD'

export const KHO_UPDATE_HOMEPAGE_FILTER = 'KHO:KHO_UPDATE_HOMEPAGE_FILTER'

export const KHO_HOMEPAGE_LIST_SUCCESS = 'KHO:FIND_HOMEPAGE_LIST_SUCCESS'
export const KHO_HOMEPAGE_LIST_FAILD = 'KHO:FIND_HOMEPAGE_LIST_FAILD'

export const KHO_HOMEPAGE_ONE_SUCCESS = 'KHO:FIND_HOMEPAGE_ONE_SUCCESS'
export const KHO_HOMEPAGE_ONE_FAILD = 'KHO:FIND_HOMEPAGE_ONE_FAILD'

export const KHO_LIMIT_UPDATE_HOMEPAGE_FILTER = 'KHO:KHO_LIMIT_UPDATE_HOMEPAGE_FILTER'

export const KHO_LIMIT_HOMEPAGE_LIST_SUCCESS = 'KHO:LIMIT_FIND_HOMEPAGE_LIST_SUCCESS'
export const KHO_LIMIT_HOMEPAGE_LIST_FAILD = 'KHO:LIMIT_FIND_HOMEPAGE_LIST_FAILD'

export const KHO_LIMIT_HOMEPAGE_ONE_SUCCESS = 'KHO:LIMIT_FIND_HOMEPAGE_ONE_SUCCESS'
export const KHO_LIMIT_HOMEPAGE_ONE_FAILD = 'KHO:LIMIT_FIND_HOMEPAGE_ONE_FAILD'

export const KhoAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    setTrangThai,
    updateFilter,

    homepageList,
    updateHomepageFilter,
    homepageFindOne,

    homepageLimitList,
    updateHomepageLimitFilter,
    homepageLimitFindOne,

    sendOrder,
    proList,
}

function updateHomepageFilter(payload) {
    return { type: KHO_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { kho } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageKhoFilter } = kho;
        const homepageKhoPage = homepageKhoFilter.homepageKhoPage;
        const homepageKhoLimit = homepageKhoFilter.homepageKhoLimit;

        return new Promise((resolve, reject) => {
            KhoService.homepageList(homepageKhoFilter).then((rs) => {
                if (!!homepageKhoFilter && homepageKhoFilter.homepageKhoPage === 0) {
                    dispatch(success({
                        homepageKhoItems: rs.data.values,
                        homepageKhoTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = kho.homepageKhoItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageKhoLimit * homepageKhoPage; i < homepageKhoLimit * homepageKhoPage + homepageKhoLimit; i++) {
                        if (typeof rsDataValues[i - homepageKhoLimit * homepageKhoPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageKhoLimit * homepageKhoPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageKhoItems: uniqueItems,
                        homepageKhoTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: KHO_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHO_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhoService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHO_HOMEPAGE_ONE_FAILD, error } }
}

function updateHomepageLimitFilter(payload) {
    return { type: KHO_LIMIT_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageLimitList() {
    return (dispatch, getState) => {
        const { kho } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageKhoLimitFilter } = kho;
        const homepageKhoLimitPage = homepageKhoLimitFilter.homepageKhoLimitPage;
        const homepageKhoLimitLimit = homepageKhoLimitFilter.homepageKhoLimitLimit;

        return new Promise((resolve, reject) => {
            KhoService.homepageLimitList(homepageKhoLimitFilter).then((rs) => {
                if (!!homepageKhoLimitFilter && homepageKhoLimitFilter.homepageKhoLimitPage === 0) {
                    dispatch(success({
                        homepageKhoLimitItems: rs.data.values,
                        homepageKhoLimitTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = kho.homepageKhoLimitItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageKhoLimitLimit * homepageKhoLimitPage; i < homepageKhoLimitLimit * homepageKhoLimitPage + homepageKhoLimitLimit; i++) {
                        if (typeof rsDataValues[i - homepageKhoLimitLimit * homepageKhoLimitPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageKhoLimitLimit * homepageKhoLimitPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageKhoLimitItems: uniqueItems,
                        homepageKhoLimitTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: KHO_LIMIT_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHO_LIMIT_HOMEPAGE_LIST_FAILD, error } }
}

function homepageLimitFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhoService.homepageLimitFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_LIMIT_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHO_LIMIT_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: KHO_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhoService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhoAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: KHO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHO_CREATE_FAILD, error } }
}

function setTrangThai(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhoService.setTrangThai(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhoAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: KHO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHO_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhoService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: KHO_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { kho } = getState()
        dispatch(AppAction.appLoading(true));
        KhoService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...kho.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHO_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { kho } = getState();
        const page = kho && typeof kho.filter !== 'undefined' && kho.filter && typeof kho.filter.page !== 'undefined' ? kho.filter.page : 0;
        const limit = kho && typeof kho.filter !== 'undefined' && kho.filter && typeof kho.filter.limit !== 'undefined' ? kho.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            KhoService.findAll(page, limit, kho.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                        summary: rs.data.summary,
                    }));
                    
                    resolve(rs);
                } else {
                    const oldItems = kho.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                        summary: rs.data.summary,
                    }));

                    resolve(rs);
                }
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: KHO_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHO_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: KHO_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            KhoService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(KhoAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: KHO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: KHO_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            KhoService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhoAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
                // alert("Không thể tạo, có thể do lỗi hệ thống. Vui lòng thử lại sau!");
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: KHO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHO_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhoService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(KhoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHO_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhoService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(KhoAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_DEL_SUCCESS, data } }
    function failure(error) { return { type: KHO_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhoService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHO_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhoService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(KhoAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { kho } = getState()
        dispatch(AppAction.appLoading(true));
        KhoService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...kho.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHO_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        KhoService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt này do hiện tại đang tạm hết hàng. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHO_ORDER_SUCCESS, data } }
    function failure(error) { return { type: KHO_ORDER_FAILD, error } }
}

function proList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhoService.proList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}